import { ReactNode } from "react";
import cx from "classnames";

import Box from "ds/components/Box";
import TooltipInfo from "ds/components/TooltipInfo";
import Typography, { TypographyProps } from "ds/components/Typography";

import styles from "./styles.module.css";

type ScanResourcesSummaryTileProps = {
  title: string;
  value: ReactNode;
  infoTooltip: string;
  valueColor?: TypographyProps["color"];
  withDivider?: boolean;
};

const ScanResourcesSummaryTile = ({
  title,
  value,
  infoTooltip,
  valueColor = "primary",
  withDivider = false,
}: ScanResourcesSummaryTileProps) => (
  <Box
    direction="column"
    gap="small"
    padding="large"
    grow="1"
    className={cx(styles.tile, withDivider && styles.withDivider)}
  >
    <Box align="center" gap="medium">
      <Typography variant="p-t7" tag="span" color="primary">
        {title}
      </Typography>
      <TooltipInfo>{infoTooltip}</TooltipInfo>
    </Box>
    <Typography variant="p-t4" tag="span" color={valueColor}>
      {value}
    </Typography>
  </Box>
);

export default ScanResourcesSummaryTile;
